<template>
  <div class="Hero">
    <div class="fullscreen-bg">
      <video loop muted playsinline autoplay poster="../assets/video/Home_hoch.jpg" class="fullscreen-bg__video fullscreen-bg__video--mobile">
          <source class="fullscreen-bg__video--mobile" src="../assets/video/TAMA_Sommerquiz_26_9x16_komprimiert.mp4" type="video/mp4">
      </video>
      <video loop muted autoplay poster="../assets/video/Home_quer.jpg" class="fullscreen-bg__video fullscreen-bg__video--desktop">
          <source class="fullscreen-bg__video--desktop" src="../assets/video/TAMA_Sommerquiz_26_16x9_komprimiert.mp4" type="video/mp4">
      </video>
    </div>
    <div class="Hero__content">
      <h1 class="Hero__headline">Testen Sie Ihr Wissen über die Schweiz</h1>
      <p>
        und gewinnen Sie drei unvergessliche Übernachtungen für Zwei im Romantik Hotel Bären und einen von 100 Sofortpreisen.
      </p>
      <img class="Hero__image" src="../assets/verlosung.svg" alt="Verlosung" />
      
      <div class="Hero__button-container">
        <div class="Hero__button Hero__button--desktop">
          <Button link="/quiz/1" text="Quiz starten" :router-link="true" />
        </div>
      </div>

    </div>
    <div class="Hero__button Hero__button--mobile">
      <Button link="/quiz/1" text="Quiz starten" :router-link="true" />
    </div>
  </div>
</template>

<script>
import Button from './Button'

export default {
  name: "Hero",
  components: {
    Button
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/Hero.scss";
</style>
